<template>
    <div class="d-flex align-items-center gap-3 w-100 flex-grow-1">
        <ImageLoader :size="44" :src="item.images?.[0]" image-class="" />
        <div class="d-flex gap-1 flex-column">
            <div class="font-weight-bold">{{ item.name }}</div>
            <div class="d-flex align-items-center gap-3">
                <span class="text-secondary">ID: {{ item.id }}</span>
                <span class="text-secondary">SKU: {{ item.sku }}</span>
                <span class="text-secondary">EAN: {{ item.ean }}</span>
            </div>
        </div>
        <div v-if="btnRemove" class="ml-auto">
            <ButtonIcon size="sm" icon="trash-2" variant="outline-secondary" class="p-2 rounded-max border-0" @click="$emit('remove', item)" />
        </div>
    </div>
</template>



<script>
    import ImageLoader from '@/components/common/ImageLoader.vue';

    export default {
        name: 'ProducerProductItem',
        components: {
            ImageLoader,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
            btnRemove: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {};
        },
    };
</script>
